import { EXTERNAL_LINKS } from "@repo/common";

const readEpisodeNumber = (item: Element): string | undefined => {
  const tagged = item.getElementsByTagName("itunes:episode").item(0)?.textContent?.trim();

  if (tagged) {
    return tagged;
  }

  return item.getElementsByTagNameNS("*", "episode").item(0)?.textContent?.trim() || undefined;
};

/**
 * LetsCast `itunes:episode` for an item whose title equals `title`.
 * Returns undefined when no item matches.
 */
const episodeNumberFromFeedXml = (xml: string, title: string): string | undefined => {
  const parsed = new DOMParser().parseFromString(xml, "text/xml");
  const items = parsed.getElementsByTagName("item");

  for (let index = 0; index < items.length; index += 1) {
    const item = items.item(index);

    if (!item) {
      continue;
    }

    if (item.getElementsByTagName("title").item(0)?.textContent !== title) {
      continue;
    }

    return readEpisodeNumber(item);
  }

  return undefined;
};

/**
 * Loads the LetsCast feed and copies the episode number for an exact title.
 * Throws when the feed cannot be read so the caller can keep the stored number.
 */
export const episodeNumberForTitle = async (title: string): Promise<string | undefined> => {
  const response = await fetch(EXTERNAL_LINKS.LETS_CAST_FEED_URL);

  if (!response.ok) {
    throw new Error(`Podcast feed responded ${String(response.status)}`);
  }

  const xml = await response.text();

  return episodeNumberFromFeedXml(xml, title);
};
